export const countriesData = [
  {
    id: 1,
    country_code: "IN",
    phonecode: "+91",
    maxNumPhone: 12,
    minNumPhone: 9,
    isoCode: "INR",
    name: "India",
    flagEmoji: "🇮🇳",
    currency: null,
  },
  {
    id: 4,
    country_code: "AF",
    phonecode: "+93",
    maxNumPhone: 12,
    minNumPhone: 8,
    isoCode: "AFN",
    name: "Afghanistan",
    flagEmoji: "🇦🇫",
    currency: null,
  },
  {
    id: 5,
    country_code: "PK",
    phonecode: "+92",
    maxNumPhone: 12,
    minNumPhone: 8,
    isoCode: "PKR",
    name: "Pakistan",
    flagEmoji: "🇵🇰",
    currency: null,
  },
  {
    id: 3,
    country_code: "GB",
    phonecode: "+44",
    maxNumPhone: 12,
    minNumPhone: 8,
    isoCode: "GBP",
    name: "UK",
    flagEmoji: "🇬🇧",
    currency: null,
  },
  {
    id: 2,
    country_code: "AE",
    phonecode: "+971",
    maxNumPhone: 12,
    minNumPhone: 8,
    isoCode: "AED",
    name: "United Arab Emirates",
    flagEmoji: "🇦🇪",
    currency: null,
  },
];
